<p-tabView *ngIf="entidade">
  <p-tabPanel header="Indisponibilidade">
    <div class="p-fluid">
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label>Id:</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <input pInputText type="text" name="id" readonly [ngModel]="entidade.id" disabled  />
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label>Data início:</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <p-calendar
            [(ngModel)]="entidade.dataInicio"
            [showTime]="true"
            inputId="dataInicio"
            hourFormat="24"
            [dateFormat]="'dd/mm/yy'"
            [showIcon]="true">
          </p-calendar>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label>Data fim:</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <p-calendar
            [(ngModel)]="entidade.dataFim"
            [showTime]="true"
            inputId="dataFim"
            hourFormat="24"
            [dateFormat]="'dd/mm/yy'"
            [showIcon]="true">
          </p-calendar>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label>Tipo:</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <p-dropdown
            placeholder="Favor selecionar o tipo"
            [options]="indisponibilidadeTipoItens"
            [(ngModel)]="entidade.tipo">
          </p-dropdown>
       </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label>Descrição:</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <p-editor
            [(ngModel)]="entidade.descricao"
            [style]="{ height: '320px' }">
          </p-editor>
          <div class="p-text-right">
            {{entidade.descricao?.length || 0 }} / 3000 caracteres
            <div *ngIf="entidade.descricao?.length > 3000">
            <p-message severity="error" text="Limite de caracteres excedido!" styleClass="p-mr-2"></p-message>
            </div>
          </div>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label>Afetou Latência?</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <p-checkbox [(ngModel)]="entidade.suspendePrazos" binary="true" ></p-checkbox>
        </div>
      </div>
    </div>
  </p-tabPanel>
</p-tabView>

